import { render, staticRenderFns } from "./HomeMedico.vue?vue&type=template&id=baed710c&scoped=true"
import script from "./HomeMedico.vue?vue&type=script&lang=js"
export * from "./HomeMedico.vue?vue&type=script&lang=js"
import style0 from "./HomeMedico.vue?vue&type=style&index=0&id=baed710c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed710c",
  null
  
)

export default component.exports